__turbopack_context__.v({
  "forwardText": "index-module-scss-module__2sB_OW__forwardText",
  "marginTop": "index-module-scss-module__2sB_OW__marginTop",
  "recallText": "index-module-scss-module__2sB_OW__recallText",
});
